/* global angular */
( function () {
	'use strict';

	function Filter ( coreservice, logger, collectionService, $scope, deepLoadingStatusService, TOOLTIP_MESSAGES ) {
		var self = this;

		self.title   = 'Filter';
		self.tooltip = TOOLTIP_MESSAGES;

		function bindTagEntry ( model ) {
			var data = model || {};

			return data;
		}

		function addFilterTagHandler () {
			collectionService.addModel( self.model.children, angular.copy( bindTagEntry() ) );
		}

		function removeFilterTagHandler ( focusedTag ) {
			collectionService.removeModel( self.model.children, focusedTag );
		}

		function tagViewHandler ( tag ) {
			tag.edit = !tag.edit;
		}

		function cancelTagChanges ( tag, prevTagName ) {
			tag.tagName = prevTagName;
		}

		function toggleMode ( mode ) {
			self.mode = mode;
		}

		function tagCountHandler () {
			return self.model.children.length < 2;
		}

		// TODO separate service
		function duplicateFilter ( model ) {
			return model.id !== ( self.model.originalHash || self.model.id );
		}

		function duplicateMapper ( model ) {
			return model.filterName.toLowerCase();
		}

		function duplicateValidator ( value ) {
			if ( self.collection ) {
				return self.collection.filter( duplicateFilter ).map( duplicateMapper )
					.indexOf( ( value || '' ).toLowerCase() ) === -1;
			}
			return true;
		}
		// end

		function closeEditPanel ( done ) {
			self.onEdit();
			if ( done ) {
				self.onUpdate();
			}
		}

		function checkOpen () {
			return $scope.$parent.$parent.vm.hasEdit;
		}

		function activate () {
			deepLoadingStatusService.decrementLoading( null, 'filter' );
		}

		self.characterLimit         = 25;
		self.addFilterTagHandler    = addFilterTagHandler;
		self.removeFilterTagHandler = removeFilterTagHandler;
		self.tagViewHandler         = tagViewHandler;
		self.cancelTagChanges       = cancelTagChanges;
		self.toggleMode             = toggleMode;
		self.tagCountHandler        = tagCountHandler;
		self.duplicateValidator     = duplicateValidator;
		self.closeEditPanel         = closeEditPanel;
		self.checkOpen              = checkOpen;
		activate();
	}

	angular
		.module( 'app.templates' )
		.controller( 'Filter', Filter );

	Filter.$inject = [ 'coreservice', 'logger', 'collectionService', '$scope', 'deepLoadingStatusService', 'TOOLTIP_MESSAGES' ];
} )( );
